import { type ReactNode } from 'react'
import { isNotEmpty } from '@terros/common'
import { Box, Stack, Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import { PreviewReviews } from './PreviewReviews'
import { PreviewMobileHero } from './PreviewMobileHero'
import { PreviewGallery } from './PreviewGallery'
import { type CardPreviewProps } from './previewContent'

export const MobileCardPreview = ({ content, tokens }: CardPreviewProps): ReactNode => {
  const { t } = useTranslation()

  return (
    <Stack bg={tokens.page} gap='xl' pb='xl'>
      <PreviewMobileHero content={content} tokens={tokens} />
      <Stack gap='xl' px='lg'>
        {content.showCta && (
          <Box bdrs='xl' bg={tokens.accent} c={tokens.onAccent} py='md' ta='center'>
            <Text fw='bold' size='lg'>
              {t('Leave a review')}
            </Text>
          </Box>
        )}
        {isNotEmpty(content.gallery) && <PreviewGallery images={content.gallery} ink={tokens.ink} layout='mobile' />}
        {content.showReviews && (
          <PreviewReviews
            hasGoogleBusinessProfile={content.hasGoogleBusinessProfile}
            rating={content.rating}
            reviewCount={content.reviewCount}
            review={content.review}
            tokens={tokens}
          />
        )}
      </Stack>
    </Stack>
  )
}
